<template>
  <div class="flex w-full h-screen items-center justify-center flex-col">
    <svg
      width="160"
      height="160"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_315_112)">
        <path
          d="M203.304 104.798C223.997 86.1621 254.363 82.9423 278.521 96.8222L408.484 171.498C432.641 185.378 445.096 213.201 439.328 240.415L408.318 386.829C402.553 414.044 379.882 434.459 352.164 437.396L203.032 453.211C175.313 456.148 148.85 440.944 137.483 415.546L76.3269 278.907C64.9597 253.509 71.2747 223.696 91.9688 205.06L203.304 104.798Z"
          fill="url(#paint1_radial_315_112)"
          fill-opacity="0.25"
        />
      </g>
      <path
        d="M211.346 52.6309C232.04 33.9951 262.406 30.7752 286.564 44.6553L416.527 119.331C440.684 133.211 453.139 161.034 447.371 188.248L416.361 334.662C410.595 361.877 387.925 382.291 360.207 385.23L211.075 401.043C183.356 403.983 156.893 388.778 145.526 363.381L84.3697 226.739C73.0026 201.341 79.3176 171.529 100.012 152.893L211.346 52.6309Z"
        fill="url(#paint0_linear_315_112)"
      />
      <path
        d="M348.921 163.206C355.711 168.89 356.642 179.008 350.968 185.803L259.617 295.189C253.668 302.312 242.927 302.939 236.187 296.556L196.128 258.62C190.219 253.024 189.876 243.742 195.356 237.729C200.987 231.548 210.601 231.171 216.699 236.894L233.547 252.709C240.379 259.12 251.239 258.363 257.111 251.064L326.011 165.432C331.659 158.414 342.011 157.423 348.921 163.206Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_315_112"
          x="58.7313"
          y="76.2563"
          width="393.993"
          height="389.316"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_315_112" />
        </filter>
        <linearGradient
          id="paint0_linear_315_112"
          x1="246.052"
          y1="21.3777"
          x2="289.635"
          y2="432.403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3555FE">
            <animate
              attributeName="stop-color"
              values="#40BAE7;#3555FE;#40BAE7;"
              dur="3s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="1" stop-color="#40BAE7">
            <animate
              attributeName="stop-color"
              values="#3555FE;#40BAE7;#3555FE;"
              dur="4s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
        <radialGradient
          id="paint1_radial_315_112"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(259.893 279.049) rotate(83.9214) scale(206.666 207.101)"
        >
          <stop stop-color="#407BFF" />
          <stop offset="1" stop-color="#407BFF">
            <animate
              attributeName="stop-color"
              values="transparent;#407BFF;transparent;"
              dur="3s"
              repeatCount="indefinite"
            />
          </stop>
        </radialGradient>
      </defs>
    </svg>
    <h2 class="font-medium text-xl mt-3 dark:text-white">Loading...</h2>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.base {
}
</style>
>
